import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appLocale, currentAppLang, formatVwNumber } from './vw-date.pipe';

/**
 * Part éclairée de la lune, en pourcentage entier dans la langue de l'app :
 * « 74 % » en français (espace insécable), « 74% » en anglais. WeatherAPI l'envoie déjà en
 * pourcentage (0 à 100, entier) ; une valeur décimale sous 1 est une fraction
 * (0,74) et passe en pourcentage. Vide pour une valeur absente.
 */
export function formatVwPercent(value: number | null | undefined, lang: string | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '';
  const fraction = value > 0 && value < 1 && !Number.isInteger(value) ? value : value / 100;
  return new Intl.NumberFormat(appLocale(lang), { style: 'percent', maximumFractionDigits: 0 }).format(fraction);
}

/**
 * `{{ day.tempMax | vwNumber }}` → « 10,5 » en français, « 10.5 » en anglais :
 * une décimale au plus, dans la langue de l'app. Impur pour suivre un
 * changement de langue, comme `vwDate`.
 */
@Pipe({ name: 'vwNumber', standalone: true, pure: false })
export class VwNumberPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: number | null | undefined, maximumFractionDigits = 1): string {
    return formatVwNumber(value, currentAppLang(this.translate), maximumFractionDigits);
  }
}

/** `{{ day.moonIllumination | vwPercent }}` → « 74 % ». */
@Pipe({ name: 'vwPercent', standalone: true, pure: false })
export class VwPercentPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: number | null | undefined): string {
    return formatVwPercent(value, currentAppLang(this.translate));
  }
}
